import React from "react";
import { WebsiteBlockType } from "../../../cores/websitePage/interfaces/WebsiteBlock";
import "./BlockThumbnail.scss";

interface Props {
  type: WebsiteBlockType;
}

export function BlockThumbnail({ type }: Props) {
  return (
    <div className={`wp-block-thumb wp-block-thumb--${type}`} aria-hidden="true">
      {type === "hero" && (
        <>
          <div className="wp-block-thumb__hero-bg" />
          <div className="wp-block-thumb__hero-lines">
            <span className="wp-block-thumb__line wp-block-thumb__line--lg" />
            <span className="wp-block-thumb__line wp-block-thumb__line--md" />
            <span className="wp-block-thumb__pill" />
          </div>
        </>
      )}
      {type === "columns" && (
        <div className="wp-block-thumb__cols">
          <div className="wp-block-thumb__col">
            <span /><span /><span />
          </div>
          <div className="wp-block-thumb__col">
            <span /><span /><span />
          </div>
        </div>
      )}
      {type === "spacer" && (
        <div className="wp-block-thumb__spacer">
          <span className="wp-block-thumb__spacer-arrow">↑</span>
          <div className="wp-block-thumb__spacer-gap" />
          <span className="wp-block-thumb__spacer-arrow">↓</span>
        </div>
      )}
      {type === "header" && (
        <div className="wp-block-thumb__header">
          <span className="wp-block-thumb__line wp-block-thumb__line--xl" />
        </div>
      )}
      {type === "text" && (
        <div className="wp-block-thumb__text">
          <span className="wp-block-thumb__line wp-block-thumb__line--full" />
          <span className="wp-block-thumb__line wp-block-thumb__line--full" />
          <span className="wp-block-thumb__line wp-block-thumb__line--short" />
        </div>
      )}
      {type === "image" && (
        <div className="wp-block-thumb__image">
          <svg viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="32" rx="4" fill="currentColor" opacity="0.15" />
            <circle cx="14" cy="11" r="4" fill="currentColor" opacity="0.35" />
            <path d="M4 26 L18 16 L28 22 L38 12 L44 18 V28 H4 Z" fill="currentColor" opacity="0.4" />
          </svg>
        </div>
      )}
      {type === "gallery" && (
        <div className="wp-block-thumb__gallery">
          <span /><span /><span /><span />
        </div>
      )}
      {type === "video" && (
        <div className="wp-block-thumb__video">
          <span className="wp-block-thumb__play">▶</span>
        </div>
      )}
      {type === "button" && (
        <div className="wp-block-thumb__button">
          <span className="wp-block-thumb__pill wp-block-thumb__pill--solid" />
        </div>
      )}
      {type === "cta" && (
        <div className="wp-block-thumb__cta">
          <span className="wp-block-thumb__line wp-block-thumb__line--md wp-block-thumb__line--light" />
          <span className="wp-block-thumb__line wp-block-thumb__line--sm wp-block-thumb__line--light" />
          <span className="wp-block-thumb__pill wp-block-thumb__pill--light" />
        </div>
      )}
      {type === "testimonials" && (
        <div className="wp-block-thumb__testimonials">
          <div className="wp-block-thumb__quote-card">
            <span>“</span>
            <span /><span />
          </div>
          <div className="wp-block-thumb__quote-card">
            <span>“</span>
            <span /><span />
          </div>
        </div>
      )}
      {type === "faq" && (
        <div className="wp-block-thumb__faq">
          <div><span /><small>+</small></div>
          <div><span /><small>+</small></div>
          <div><span /><small>+</small></div>
        </div>
      )}
      {type === "contact-form" && (
        <div className="wp-block-thumb__form">
          <span className="wp-block-thumb__input" />
          <span className="wp-block-thumb__input" />
          <span className="wp-block-thumb__input wp-block-thumb__input--area" />
          <span className="wp-block-thumb__pill wp-block-thumb__pill--solid wp-block-thumb__pill--sm" />
        </div>
      )}
      {type === "footer" && (
        <div className="wp-block-thumb__footer">
          <span className="wp-block-thumb__line wp-block-thumb__line--md wp-block-thumb__line--light" />
          <span className="wp-block-thumb__line wp-block-thumb__line--full wp-block-thumb__line--light" />
        </div>
      )}
      {type === "navbar" && (
        <div className="wp-block-thumb__navbar">
          <span className="wp-block-thumb__pill wp-block-thumb__pill--sm" />
          <span className="wp-block-thumb__line wp-block-thumb__line--sm" />
          <span className="wp-block-thumb__line wp-block-thumb__line--sm" />
          <span className="wp-block-thumb__line wp-block-thumb__line--sm" />
        </div>
      )}
      {type === "html-page" && (
        <div className="wp-block-thumb__html">
          <span className="wp-block-thumb__line wp-block-thumb__line--full" />
          <span className="wp-block-thumb__line wp-block-thumb__line--full" />
          <span className="wp-block-thumb__line wp-block-thumb__line--short" />
          <span className="wp-block-thumb__tag">&lt;/&gt;</span>
        </div>
      )}
    </div>
  );
}
